import { runtimeConfig } from './runtimeConfig';

export const dateRange = {
  MAX_MONTH_DATE_RANGE: runtimeConfig.MAX_MONTH_DATE_RANGE,
};
